import { TextField, Typography } from '@material-ui/core';
import { FC, ReactNode } from 'react';
import YoutubeIframe from '../../../../../components/VideoYoutubeEmbed';
import {
  VideoModalActions,
  VideoModalCheckboxes,
  VideoModalCheckboxState,
  VideoModalHeader,
} from './VideoModalShared';
import { useVideoImportStyles } from './VideoImport.styles';

type VideoImportYoutubeModalProps = VideoModalCheckboxState & {
  onClose: () => void;
  onBack: () => void;
  url: string;
  onUrlChange: (url: string) => void;
  youtubeInputId: string;
  showYoutubePreview: boolean;
  validateYoutubeUrl: (url: string) => boolean;
  submitError: string;
  onValidate: () => void;
  tabs?: ReactNode;
  showHeader?: boolean;
  submitLabel?: ReactNode;
  validateDisabled?: boolean;
};

const VideoImportYoutubeModal: FC<VideoImportYoutubeModalProps> = ({
  onClose,
  onBack,
  url,
  onUrlChange,
  youtubeInputId,
  showYoutubePreview,
  validateYoutubeUrl,
  submitError,
  onValidate,
  tabs,
  showHeader = true,
  submitLabel = 'Valider',
  validateDisabled,
  ...checkboxState
}) => {
  const classes = useVideoImportStyles();
  return (
    <>
      {showHeader && <VideoModalHeader title="Ajouter une vidéo Youtube" onClose={onClose} />}
      {tabs}
      <div className={classes.videoModalForm}>
        <div>
          <Typography className={classes.videoModalFieldLabel}>URL de la vidéo YouTube</Typography>
          <TextField
            id={youtubeInputId}
            variant="outlined"
            className={classes.videoModalInput}
            name="video"
            value={url}
            onChange={e => onUrlChange(e.target.value)}
            placeholder="https://www.youtube.com/watch?v=..."
            fullWidth={true}
          />
        </div>
        {showYoutubePreview && url && validateYoutubeUrl(url) && (
          <div className={classes.youtubePreviewBox}>
            <Typography className={classes.youtubePreviewTitle}>Aperçu de la vidéo</Typography>
            <div className={classes.youtubePreviewPlayer}>
              <YoutubeIframe url={url} autoPlay={0} mute={1} />
            </div>
          </div>
        )}
        {submitError && (
          <Typography className={classes.videoUploadError}>{submitError}</Typography>
        )}
        <VideoModalCheckboxes {...checkboxState} />
      </div>
      <VideoModalActions
        validateLabel={submitLabel}
        validateDisabled={validateDisabled ?? (!url || !validateYoutubeUrl(url))}
        onValidate={onValidate}
        onBack={onBack}
      />
    </>
  );
};

export default VideoImportYoutubeModal;
